/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:00:33
 */

import {type AnySchema, object} from 'yup';

// helpers
import {genericFieldsSchema, HandleProps} from '~/helpers/form-fields';

// types
import type {SnapPackMailerField, SnapPackMailerFields} from './fields-info';

export type SnapPackMailerProps = HandleProps<SnapPackMailerFields>

export const schema = object<SnapPackMailerFields, Record<SnapPackMailerField, AnySchema>>()
  .shape({
    ...genericFieldsSchema,
  });
